// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1vdtE","fadein":"hero-module--fadein--3FjNC","heading":"hero-module--heading--1xQ2O"};